import type { GetProjectResponse } from '../api/types';
import type { Project } from '../Components/Projects/projects';
import { applyProjectVersionDefaults, pickProjectVersionFields } from './projectVersions';

type ProjectStringResponse = Pick<GetProjectResponse, 'project_string'> & Partial<Pick<GetProjectResponse, 'version' | 'framework_version'>>;

export function applyProjectApiMetadata<T extends Project>(project: T, source: unknown): T {
  return applyProjectVersionDefaults({
    ...project,
    ...pickProjectVersionFields(source),
  }) as T;
}

export function parseProjectFromApiResponse(response: ProjectStringResponse): Project {
  return applyProjectApiMetadata(JSON.parse(response.project_string) as Project, response);
}
